import { render } from "./GuiRegionSelect.vue?vue&type=template&id=073cba10"
import script from "./GuiRegionSelect.vue?vue&type=script&lang=js"
export * from "./GuiRegionSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__